import tree from "../../../components/tree.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";
import ITable from "./config/tableDemo.vue";
import { domainName } from "../../../utility/index"
import moment from 'moment';

export default {
  name: "VehicleOrgReport",
  components: {
    tree,
    iTable,
    IPagination,
    ITable
  },
  data() {
    return {
      isCollapse: false,
      stateArrow: true,
      isSearch: true,
      // activeName: 'first',
      orgId: '',
      formInline: {
        numberType: '',
        number: '',
        workDay: ''
      },
      optionsInput: [{
        value: '0',
        label: this.$t('common.all')
      }, {
        value: '1',
        label: this.$t('VehicleAnalysis.carId')
      }, {
        value: '2',
        label: this.$t('VehicleAnalysis.plateNum')
      },
      {
        value: '3',
        label: this.$t('VehicleAnalysis.manufactureNum')
      },
      {
        value: '4',
        label: this.$t('VehicleAnalysis.customNum')
      }],
      changeValue: [],
      height: '500',
      list: [],
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: false,
        serialNumber: true,
      },
      columns: [],
      operates: {
        width: 100,
        fixed: "right",
        list: [],
      },
      currentPage: 1,
      pageSize: 10,
      total: 1,
    };
  },
  mounted() {
    this.getDate()
  },
  methods: {
    toggleSideBar() {
      this.isCollapse = !this.isCollapse
      this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
    },
    changeArrow() {
      this.stateArrow = !this.stateArrow
    },
    getDate() {
      this.formInline.workDay = moment().subtract(1, "day").format("YYYY-MM-DD");
    },

    getMonthOrderList() {
      let param = {
        orgId: this.orgId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        workDay: this.formInline.workDay,
        numberType: this.formInline.numberType,
        number: this.formInline.number
      };
      this.$store.dispatch('ReportAnalysis/GET_SELECTCARDAYWORKDISTRIBUTION', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            const tableColumn = res.data.data.label.map((item, index) => {
              const obj = {
                align: "center",
                prop: item.prop,
                label: item.label,
                width: "100",
                render: (h, params) => {
                  console.log(h, params, params.row[item.prop])
                  return h(ITable, {
                    props: {
                      time: params.row[item.prop]
                    }
                  })
                }

              };
              return obj;
            })
            this.columns = tableColumn
            this.list = res.data.data.data.list
            this.$refs.page.CommandTotal = res.data.data.data.total
          }
        }
      }).catch(err => { })
    },
    onSearch() {
      this.getMonthOrderList()
    },
    onClear() {
      this.formInline.numberType = ''
      this.formInline.number = ''
      this.getDate()
      this.getMonthOrderList()
    },
    downCar() {
      if (domainName) {
        if (domainName.split(':')[0] !== 'localhost') {
          let url = `https://${domainName}/v1/getExportExcel/exportCarDayWorkDistribution?orgId=${this.orgId}&workDay=${this.formInline.workDay}&numberType=${this.formInline.numberType}&number=${this.formInline.number}`
          location.href = url
        } else {
          let host = 'localhost:8080'
          let url = `https://${host}/v1/getExportExcel/exportCarDayWorkDistribution?orgId=${this.orgId}&workDay=${this.formInline.workDay}&numberType=${this.formInline.numberType}&number=${this.formInline.number}`
          location.href = url
        }
      }
    },
    handleSelectionChange(val) {
      this.selected = val
    },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getMonthOrderList()
    },
    // handleClick(event) {
    //   this.activeName = event.name
    //   if (this.activeName == 'first') {
    //     this.$nextTick(() => {
    //       this.$refs.monthTime.orgId = this.orgId
    //       this.$refs.monthTime.getMonthOrderList()
    //     })
    //   } else {
    //     this.$nextTick(() => {
    //       this.$refs.changeTime.orgId = this.orgId
    //       this.$refs.changeTime.getMonthOrderList()
    //     })

    //   }
    // },
    initQuery(item) {
      this.orgId = item.id
      this.getMonthOrderList()
    },
    nodeClick(val) {
      this.orgId = val.label
      this.getMonthOrderList()
    },
    onResize: function (x, y, width, height) {
      let box = document.getElementById("leftBox");
      box.style.width = width + "px";
    },
  },
};
